import axios from 'axios';

// Moved to `utils/age.js` (STACK-544) and re-exported here, so every existing
// caller is unchanged. It moved because this module imports `axios`, which is
// ESM-only and untransformable by Jest: anything importing a pure helper from
// here inherits that, and a date calculation should not need a test to mock an
// HTTP client.
export { calculateAge } from './utils/age';

export const fetchConditions = async (config) => {
  try {
    const response = await axios.get(`${config.FIREBASE_STORAGE_BASE_URL}config%2Fconditions.json?alt=media`);
    const conditionsList = response.data;
    return conditionsList;
  } catch (error) {
    console.error('Error fetching conditions:', error);
    return [];
  }
};

export const fetchSupplements = async (config) => {
  try {
    const response = await axios.get(`${config.FIREBASE_STORAGE_BASE_URL}config%2Fsupplements.json?alt=media`);
    const supplementsList = response.data;
    return supplementsList;
  } catch (error) {
    console.error('Error fetching supplements:', error);
    return [];
  }
};